import React from 'react';
import i18next from "../../i18n.js";
import { useNavigate, NavLink } from "react-router-dom";
import { urls, docTypeSearchParams, alfrescoTypes } from '../../constants.js';
import { Button } from 'react-bootstrap';

const NewDocumentWidget = (props) => {
    const navigate = useNavigate();
    const handleBtnClick = () => {
        switch (props.type) {
            case alfrescoTypes.certification:
                navigate(urls.newCertificationPage);
                break;
            case alfrescoTypes.businessTrip:
                navigate(urls.newBusinessTripPage);
                break;
            case alfrescoTypes.details:
                navigate(urls.newDetailsPage);
                break;
            case alfrescoTypes.transferRequest:
                navigate(urls.newTransferRequestPage);
                break;
        }
    }

    const getClassName = () => {
        switch (props.type) {
            case alfrescoTypes.certification:
                return 'new-certification';
            case alfrescoTypes.businessTrip:
                return 'new-businessTrip';
            case alfrescoTypes.details:
                return 'new-details';
            case alfrescoTypes.transferRequest:
                return 'new-transferRequest';
            default:
                return '';
        }
    }

    const getTitle = () => {
        switch (props.type) {
            case alfrescoTypes.certification:
                return i18next.t("widgets.certificationTitle");
            case alfrescoTypes.businessTrip:
                return i18next.t("widgets.businessTripTitle");
            case alfrescoTypes.details:
                return i18next.t("widgets.detailsTitle");
            case alfrescoTypes.transferRequest:
                return i18next.t("widgets.transferRequestTitle");
            default:
                return '';
        }
    }

    const getLinkTitle = () => {
        switch (props.type) {
            case alfrescoTypes.certification:
                return i18next.t("widgets.allCertificationLink");
            case alfrescoTypes.businessTrip:
                return i18next.t("widgets.allBusinessTripLink");
            case alfrescoTypes.details:
                return i18next.t("widgets.allDetailsLink");
            case alfrescoTypes.transferRequest:
                return i18next.t("widgets.allTransferRequestLink");
            default:
                return '';
        }
    }

    const getBtnTitle = () => {
        switch (props.type) {
            case alfrescoTypes.certification:
                return i18next.t("widgets.newCertification");
            case alfrescoTypes.businessTrip:
                return i18next.t("widgets.newBusinessTrip");
            case alfrescoTypes.details:
                return i18next.t("widgets.newDetails");
            case alfrescoTypes.transferRequest:
                return i18next.t("widgets.newTransferRequest");
            default:
                return '';
        }
    }

    const getSearchType = () => {
        switch (props.type) {
            case alfrescoTypes.certification:
                return docTypeSearchParams.certification;
            case alfrescoTypes.businessTrip:
                return docTypeSearchParams.businessTrip;
            case alfrescoTypes.details:
                return docTypeSearchParams.details;
            case alfrescoTypes.transferRequest:
                return docTypeSearchParams.transferRequest;
            default:
                return '';
        }
    }

    return (<div className={"widget " + getClassName()}>
        <div className="new-widget-header">
            <div className="new-widget-title">{getTitle()}</div>
            <NavLink className="more-link" to={`${urls.documentsPage}?type=${getSearchType()}`}>{getLinkTitle()}</NavLink>
        </div>
        <Button variant="secondary" onClick={handleBtnClick}>{getBtnTitle()}</Button>
    </div>);
}

export default NewDocumentWidget;